import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import SEOlinksA from '@/components/SEOlinksA';
import { getProductMsg, getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useSupportData } from '@/utils/hooks';
import getCanEnterFlag from '@/utils/getCanEnterFlag';
import { GENERAL_KEY, PRODUCT_ONLINE_LOCAL, PRODUCT_KEY } from '@/constants/powerStream';
import { getQueryAllStr } from '@/utils/common';
import ProductNav from '@/components/ProductCommon/ProductNav';

// 两种场景可以使用lazy 或 dynamic 1.非首屏渲染的模块（包含条件渲染）2.拆包大小并且做seo优化可以使用 ssr: true
const PageConH5: any = dynamic(() => import('@/componentsH5/productSmart/powerstream'), { ssr: true });
const PageConPc: any = dynamic(() => import('@/components/productSmart/powerstream'), { ssr: true });
const ProductSpecs: any = dynamic(() => import('@/components/ProductCommon/ProductSpecs'), { ssr: true });
const ProductSupport: any = dynamic(() => import('@/components/ProductCommon/ProductSupport'), { ssr: false });

export default function PowerStream({ SEO }: any) {
    const { isMobile, gloproductlist, useLang, getSystemTime } = useGlobal();
    const router = useRouter();
    const { t } = useLang('powerstream');
    const [theme, setTheme] = useState('');
    const { locale = 'eu' } = router;
    const PageCon = isMobile ? PageConH5 : PageConPc;
    const supportStr = router?.query?.support || '';
    const isShowSupport = supportStr === '1'; //是否默认显示support
    const [tabName, setTabName] = useState<string>(isShowSupport ? 'Support' : 'Overview');
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    // 从全局的列表中--获取产品详情的基本信息
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: GENERAL_KEY });

    const [resProductCatagory, productDetail, supportData] = useSupportData(getProductMsg, locale, productMsg);
    const searchUrl = getQueryAllStr(router.asPath || '');
    const searchObj = new URLSearchParams(searchUrl);
    const cid = searchObj.get('cid');

    // 提前打开
    const { flag1, flag2, flag3 } = getCanEnterFlag(cid, getSystemTime());

    // 切换tab
    const tabState = (val: any) => {
        setTabName(val);
        const target1 = document.querySelector('.product-tab.show-tab') as HTMLDivElement;
        const target2 = document.querySelector(`.product-tab-${val}`) as HTMLDivElement;
        if (target1) target1?.classList.remove('show-tab');
        if (target2) target2?.classList.add('show-tab');
    };

    useEffect(() => {
        if (isShowSupport) {
            const target2 = document.querySelector(`.detail-nav li:nth-child(3)`) as HTMLDivElement;
            target2 && target2.click();
        }
    }, [isShowSupport]);

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA list={PRODUCT_ONLINE_LOCAL} locale={locale} pathname="powerstream" />
            <GtmPageLoad />
            <PageLayout className={`${css.productcontent} ${theme} product_common product_common_real product_common_0426`} theme={theme}>
                <ProductNav
                    className="wbg"
                    title={productMsg?.name}
                    theme={theme}
                    buyLink={productMsg?.buyLink || ''}
                    callback={tabState}
                    productKey={PRODUCT_KEY}
                />
                <div className={`product-tab product-tab-Overview${tabName === 'Overview' ? ' show-tab' : ''}`}>
                    <PageCon
                        productDetail={productDetail}
                        resProductCatagory={resProductCatagory}
                        supportData={supportData}
                        callBackTheme={setTheme}
                        ecoflowflag={flag1}
                        ecoflowflag2={flag2}
                        ecoflowflag3={flag3}
                    />
                </div>
                <div className="product-tab product-tab-Specs">
                    {tabName === 'Specs' && (
                        <>
                            <ProductSpecs theme={theme} productDetail={productDetail} resProductCatagory={resProductCatagory} />
                            <div className="product-specs-tips">{t('detail.product_specs_tips')}</div>
                        </>
                    )}
                </div>
                <div className={`product-tab product-tab-Support${tabName === 'Support' ? ' show-tab' : ''}`}>
                    {tabName === 'Support' && <ProductSupport theme={theme} supportData={supportData} />}
                </div>
            </PageLayout>
        </>
    );
}
export async function getServerSideProps({ locale }: { locale: string }) {
    if (!PRODUCT_ONLINE_LOCAL.includes(locale)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
